module.exports = __webpack_public_path__ + "img/44_38.fd620c92.png";